import { render, staticRenderFns } from "./TaskTypeTable.vue?vue&type=template&id=673ed1d8"
import script from "./TaskTypeTable.vue?vue&type=script&lang=js"
export * from "./TaskTypeTable.vue?vue&type=script&lang=js"
import style0 from "./TaskTypeTable.vue?vue&type=style&index=0&id=673ed1d8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./locales.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2FUsers%2Fstv%2FPycharmProjects%2FcomponentDB%2Fvueapp%2Fsrc%2Fcomponents%2FProduct%2FTaskType%2FTaskTypeTable.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports